/** When your routing table is too long, you can split it into small modules **/
import Layout from "@/layout";

const shopsRouter = {
  path: "/user",
  component: Layout,
  redirect: "/user/list",
  meta: { title: "患者管理", icon: "el-icon-user", roles: ["admin"] },
  children: [
    {
      path: "list",
      component: () => import("@/pages/user/list"),
      name: "list",
      meta: { title: "患者列表" },
    },
    {
      path: "edit/:id",
      hidden: true,
      component: () => import("@/pages/user/edit"),
      name: "edit",
      meta: { title: "患者编辑" },
    },
    {
      path: "detail/:id",
      hidden: true,
      component: () => import("@/pages/user/detail"),
      name: "detail",
      meta: { title: "患者详情" },
    },
  ],
};
export default shopsRouter;
